import { InteractionList } from "./InteractionList";
import { InteractionShow } from "./InteractionShow";

export default {
  list: InteractionList,
  show: InteractionShow,
  recordRepresentation: (record: { id: string | number; title?: string }) =>
    record?.title ? record.title : `Interação #${record?.id}`,
};
